import { TextFieldProps } from "@mui/material"

let clipboardApiSupported: boolean|null = null

export const isClipboardApiSupported = () => {
  // a dummy test for clipboard api
  if (clipboardApiSupported === null) {
    clipboardApiSupported = !!window.navigator.clipboard
  }
  return clipboardApiSupported
}

export const copyToClipboard = (s:string) => {
  try
  {
    return window.navigator.clipboard.writeText(s)
  }
  catch {
    return Promise.reject()
  }
}

export const autoCopyTextFieldProps = (onCopied?: ()=>void, onMouseOut1?: ()=>void): TextFieldProps => (
  isClipboardApiSupported() 
  ? {
    sx: {
      '& input': { cursor: 'pointer'},
    },
    onFocus: (e) => {
      const inputEl = 
        (e.currentTarget.tagName === 'INPUT' ? e.currentTarget : e.currentTarget.querySelector('input')) as HTMLInputElement
      inputEl.setSelectionRange(0, inputEl.value.length)
    },
    onMouseEnter: (e) => {
      const inputEl = 
        (e.currentTarget.tagName === 'INPUT' ? e.currentTarget : e.currentTarget.querySelector('input')) as HTMLInputElement
      inputEl.setSelectionRange(0, inputEl.value.length)
      inputEl.focus()
    },
    onMouseOut: (e) => {
      const inputEl = 
        (e.currentTarget.tagName === 'INPUT' ? e.currentTarget : e.currentTarget.querySelector('input')) as HTMLInputElement
      inputEl.setSelectionRange(0, 0)
      onMouseOut1 && onMouseOut1()
    },
    onClick: async (e) => {
      const inputEl = e.target as HTMLInputElement
      await copyToClipboard(inputEl.value)
      onCopied && onCopied()
    }
  }
  : {}
)
